var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SHA256, enc, lib } from "crypto-js";
/**
 * A utility class for redirect operations
 */
var Redirect = /** @class */ (function () {
    function Redirect() {
    }
    /**
     * Redirects to the given URL
     * @param url - The URL to redirect to
     */
    Redirect.redirect = function (url) {
        if (!isDefined(url)) {
            throw new Error("Missing redirect url");
        }
        window.location.assign(url);
    };
    return Redirect;
}());
export { Redirect };
/**
 * A utility class for hadling URL parameter operations
 */
var URLParams = /** @class */ (function () {
    function URLParams() {
    }
    /**
     * Gets the search parameter
     * @param key - The parameter to retrieve
     * @returns The parameter
     */
    URLParams.get = function (key) {
        return new URLSearchParams(window.location.search).get(key);
    };
    /**
     * Checks if paramter exists
     * @param key - The parameter to check
     * @returns A boolean indicating if the paramter exists
     */
    URLParams.has = function (key) {
        return new URLSearchParams(window.location.search).has(key);
    };
    /**
     * Updates URL paramters
     * @param urlStr - The URL string to update
     * @param params - The URL paramters
     * @returns The updated URL
     */
    URLParams.update = function (urlStr, params) {
        var url = new URL(urlStr);
        for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            url.searchParams.set(key, value);
        }
        return url.href;
    };
    return URLParams;
}());
export { URLParams };
/**
 * A utility class for handling operations on the client's local storage
 */
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    /**
     * Sets a key/value pair items in local storage
     * @param key - The item name
     * @param value - The item value
     */
    LocalStorage.setItem = function (key, value) {
        window.localStorage.setItem(key, value);
    };
    /**
     * Gets an item value from local storage
     * @param key - The item name
     * @returns The item value
     */
    LocalStorage.getItem = function (key) {
        return window.localStorage.getItem(key);
    };
    /**
     * Deletes a key/value pair item from local storage
     * @param key - The item name
     */
    LocalStorage.removeItem = function (key) {
        window.localStorage.removeItem(key);
    };
    return LocalStorage;
}());
export { LocalStorage };
/**
 * A utility class for handling cryptographic operations
 */
var Crypto = /** @class */ (function () {
    function Crypto() {
    }
    /**
     * Base64 encodes a string
     * @param str - The string to encode
     * @returns The encoded string
     */
    Crypto.base64UrlEncode = function (str) {
        return enc.Base64url.stringify(SHA256(str));
    };
    /**
     * Creates a random cryptographic string
     * @returns The random string
     */
    Crypto.createRandomString = function () {
        return lib.WordArray.random(28).toString(enc.Hex);
    };
    return Crypto;
}());
export { Crypto };
/**
 * A utility class for handling cookie operations
 */
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    var _a;
    _a = Cookie;
    /**
     * Sets a new cookie
     * @param name - The name of the cookie
     * @param value - The value of the cookie
     * @param domain - The domain of the cookie
     */
    Cookie.set = function (name, value, maxAge, domain) {
        // In order to set non-CloudFront cookies on localhost the domain attribute
        // must be undefined
        if (isDefined(domain)) {
            domain = "domain=".concat(domain);
        }
        var cookie = "".concat(name, "=").concat(value, ";max-age=").concat(maxAge, ";").concat(domain);
        document.cookie = cookie;
    };
    /**
     * Requests signed cookies from CloudFront
     * @param url - The CloudFront endpoint to invoke the cookie signer
     * @param token - The authenticated user's access token
     */
    Cookie.setCloudFrontSignedCookies = function (url, token) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch(url, {
                            method: "post",
                            headers: {
                                authorization: "Bearer ".concat(token),
                            },
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    throw new Error("Failed to fetch CloudFront cookies");
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Reads a cookie value
     * @param name - The name of the cookie
     * @returns The cookie value
     */
    Cookie.get = function (name) {
        var _b;
        return (((_b = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || _b === void 0 ? void 0 : _b.pop()) ||
            "");
    };
    /**
     * Expires/deletes a cookie
     * @param name - The name of the cookie
     */
    Cookie.delete = function (name) {
        document.cookie = name + "=; Max-Age=-99999999;";
    };
    return Cookie;
}());
export { Cookie };
/**
 * Checks if an object is defined
 * @param obj - the object to validate
 * @returns A boolean indicating whether the object is defined
 */
export var isDefined = function (obj) {
    return (obj != undefined &&
        obj != "undefined" &&
        obj != null &&
        obj != "null" &&
        obj != "");
};
